<div class="feed-level-layout-and-format">
  @if (visibleTabs.length) {
    <ul class="nav nav-tabs">
      @for (tab of visibleTabs; track tab) {
        <li class="nav-item">
          <a
            class="nav-link"
            [ngClass]="{ active: activeFormatTab === tab.key }"
            (click)="changeFormatTab(tab.key)"
            role="button"
          >
            @if (tab.icon) {
              <fa-icon [icon]="tab.icon" class="me-2"></fa-icon>
            }
            {{ tab.label | translate }}
          </a>
        </li>
      }
    </ul>
  }

  @if (visibleTabs.length) {
    <div class="tab-content">
      @for (tab of visibleTabs; track tab) {
        <div
          class="tab-pane fade"
          [class.show]="activeFormatTab === tab.key"
          [class.active]="activeFormatTab === tab.key"
        >
          @if (activeFormatTab === tab.key && getFormGroupForFormat(tab.key)) {
            <div>
              <app-output-settings-format-editor
                [outputSettings]="outputSettings"
                [outputFormatId]="tab.key"
                [formGroup]="getFormGroupForFormat(tab.key)"
                [searchString$]="searchString$"
              ></app-output-settings-format-editor>
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- empty state -> if no Tabs -->
  @if (!visibleTabs.length) {
    <div class="empty-state">
      {{ "output-settings.message.no-format-settings-available" | translate }}
    </div>
  }
</div>
